import { useMatches, Link } from "@tanstack/react-router";

const ROUTE_LABELS: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/jobs": "Jobs",
  "/jobs/scraped": "Scraped",
  "/jobs/search-criteria": "Search Criteria",
  "/jobs/new": "New Job",
  "/resumes": "Resumes",
  "/resumes/new": "New Resume",
  "/applications": "Applications",
  "/cover-letters": "Cover Letters",
  "/analytics": "Analytics",
  "/analytics/activity": "Activity",
  "/analytics/resume-performance": "Resume Performance",
  "/interview-prep": "Interview Prep",
  "/interview-prep/practice": "Practice",
  "/interview-prep/question-bank": "Question Bank",
  "/salary": "Salary",
  "/salary/negotiate": "Negotiate",
  "/deep-match": "Deep Match",
  "/story-bank": "Story Bank",
  "/keyword-optimizer": "Keywords",
  "/portal-scanner": "Portal Scanner",
  "/negotiation": "Negotiation",
  "/settings": "Settings",
  "/help": "Help",
  "/feedback": "Feedback",
  "/referral": "Referral",
};

export function Breadcrumbs() {
  const matches = useMatches();

  const segments = matches
    .filter((m) => m.pathname !== "/" && m.pathname !== "")
    .map((m) => ({
      path: m.pathname,
      label: ROUTE_LABELS[m.pathname] ?? extractLabel(m.pathname),
    }));

  const deduped = segments.filter(
    (seg, i) => i === 0 || seg.path !== segments[i - 1].path,
  );

  if (deduped.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 min-w-0">
      {deduped.map((seg, i) => {
        const isLast = i === deduped.length - 1;
        return (
          <span key={seg.path} className="flex items-center gap-1.5 min-w-0">
            {i > 0 && (
              <span
                className="text-[11px] select-none"
                style={{ color: "var(--border-strong)" }}
                aria-hidden="true"
              >
                /
              </span>
            )}
            {isLast ? (
              <span
                className="text-[13px] font-medium truncate"
                style={{ color: "var(--text)" }}
                aria-current="page"
              >
                {seg.label}
              </span>
            ) : (
              <Link
                to={seg.path}
                className="text-[13px] truncate transition-colors"
                style={{ color: "var(--text-muted)" }}
              >
                {seg.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}

function extractLabel(pathname: string): string {
  const last = pathname.split("/").filter(Boolean).pop() ?? "";
  if (last.startsWith("$")) return last.slice(1).replace(/-/g, " ");
  return last
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
